import React, { Component } from 'react'
import { connect } from 'react-redux'

class Error401 extends Component {
	render() {
		return (
            <div>
                Error 401
            </div>
		)
	}
}

function mapStateToProps(state) {
    return {
    }
}

function mapDispatchToProps(dispatch) {
    return {
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(Error401)


// WEBPACK FOOTER //
// ./src/containers/Error401.jsx